

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../..";
import { CountClassifierMetric } from "../../../config/types";
import { usersAnalytics, UsersCountQuery } from "../../../services/analytics/users.analytics";

interface UserMetricsState {
  classifier: CountClassifierMetric | null;
  total?: number;
  timeSeries: unknown | null;
}

const initialState: UserMetricsState = {
  classifier: {loading:true},
  timeSeries: null,
};

export const assetMetrics = createSlice({
  name: "UsersMetrics",
  initialState,
  reducers: {
    updateClassifier: (state, action: PayloadAction<CountClassifierMetric>) => {
      state.classifier = action.payload;
    },
    updateTimeSeries: (state, action: PayloadAction<unknown>) => {
      state.timeSeries = action.payload;
    },
    updateTotalCount: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    startFetch: (state) => {
        if (state.classifier) {
            state.classifier.loading = true;
          } else {
            state.classifier = { loading: true };
          }
        
      },
    
  },
});

export const { updateClassifier, updateTotalCount, updateTimeSeries,startFetch } =
  assetMetrics.actions;

export const fatchUserCountClassifier =
  (query?: UsersCountQuery): AppThunk =>
  async (dispatch) => {
    try {
      const result =  await usersAnalytics.getUsersCount(query);
      dispatch(
        updateClassifier({
          data: result.data,
          loading: false,
        })
      );
    } catch (err) {}
  };

export const fetchUserCountTotal = (): AppThunk => async (dispatch) => {
  try {
    const result = await usersAnalytics.getUsersCount({});
    if (result?.data) {
      dispatch(updateTotalCount(result.totalRecords ?? 0));
    }
  } catch (err) {}
};

export default assetMetrics.reducer;
